export default (path: string, firstPart: string) => {
  const urlParts = path.split('/')
  urlParts.splice(0, 2)
  return `/${firstPart}/${urlParts.join('/')}`
}
